import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { App } from "./App";
import { ThemeProvider } from "./contexts/theme-context";
// oxlint-disable-next-line import/default -- Vite virtual module (vite-site-data.plugin.ts) the linter cannot resolve
import siteData from "virtual:site-data";
import "virtual:fonts";
import "./index.css";

ReactDOM.hydrateRoot(
  document.getElementById("root")!,
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={siteData.theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
  {
    onRecoverableError: (error) => {
      // Suppress hydration errors in production - these are expected due to
      // Client-side enhancements like scroll state, session IDs, etc.
      const errorMsg = error.message || "",
        isHydrationError =
          errorMsg.includes("Hydration") ||
          errorMsg.includes("did not match") ||
          errorMsg.includes("#418") || // Text content mismatch
          errorMsg.includes("#423") || // Hydration failed
          errorMsg.includes("#425"); // Text content did not match

      if (isHydrationError) {
        console.warn("Hydration mismatch (expected):", errorMsg);
        return;
      }
      console.error("React error:", error);
    },
  },
);
